/**
 * @description Contains all German translations for legal pages (legal notice, privacy policy, terms of service) and the help section.
 */

export const legalNotice = {
  title: "Impressum",
  subtitle: "Angaben gemäß § 5 DDG",
  projectTitle: "Betreiber der Website",
  projectGroup: "Universität Passau",
  university:
    "Fakultät für Informatik und Mathematik\nInstitut für Data Science\nInnstraße 43, 94032 Passau, Deutschland",
  representativeTitle: "Vertreten durch",
  representativeName: "Max Mustermann",
  representativeRole: "(Technischer Leiter / Studentischer Vertreter)",
  contactTitle: "Kontakt & Anschrift",
  address:
    "Universität Passau\nFakultät für Informatik und Mathematik\nInnstraße 43, 94032 Passau, Deutschland",
  website: "https://www.fim.uni-passau.de/data-science",
  email: "webkurator@fim.uni-passau.de",
  phone: "+49(0)851 509-3306",
  projectDisclaimerTitle: "Wichtiger Hinweis zum Projektstatus",
  projectDisclaimerText:
    "Diese Webseite begann als studentisches Projekt im Rahmen des 'Entwicklungspraktikums' an der Universität Passau und wird über das Praktikum hinaus weitergeführt. Sie bleibt ein nicht-kommerzielles Angebot und ist kein offizielles Angebot der Universität. Die Inhalte dienen ausschließlich Lehr- und Demonstrationszwecken.",
  editorTitle: "Technische Leitung",
  editorName: "Ben Böck",
  editorAddress:
    "Universität Passau\nUrsprünglich entwickelt vom Entwicklungspraktikum WS 2025 / Gruppe 2 am Institut für Data Science der Universität Passau.",
  disclaimer: "Haftungsausschluss",
  disclaimerContent: "Haftung für Inhalte",
  disclaimerContentText:
    "Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.",
  disclaimerLinks: "Haftung für Links",
  disclaimerLinksText:
    "Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Beim Verlassen von WebKurator.de wird ein Warnhinweis angezeigt, da wir nicht alle eingetragenen URLs vollständig prüfen können.",
  disclaimerCopyright: "Urheberrecht",
  disclaimerCopyrightText:
    "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.",
};

export const privacy = {
  title: "Datenschutzerklärung",
  subtitle: "Informationen zur Verarbeitung Ihrer Daten",
  introTitle: "Allgemeines zum Datenschutz",
  introText: "Die Projektgruppe WebKurator nimmt den Schutz Ihrer personenbezogenen Daten sehr ernst. Wir haben technische und organisatorische Maßnahmen getroffen, die sicherstellen, dass die Vorschriften über den Datenschutz beachtet werden. Da es sich um ein studentisches Projekt handelt, beschränken wir die Datenerhebung auf das technisch Notwendige.",
  section1Title: "1. Bereitstellung der Website & Technik",
  section1Text: "Bei jedem Zugriff auf unser Angebot werden automatisch Daten erfasst, die für die Bereitstellung und Sicherheit erforderlich sind. Dazu gehören IP-Adresse (anonymisiert), Browsertyp, Betriebssystem und Zugriffszeit. Zudem nutzen wir den 'Local Storage' Ihres Browsers, um Ihre Einstellungen (z.B. Dunkelmodus) lokal zu speichern. Es findet keine Zusammenführung dieser Daten mit anderen Datenquellen statt.",
  section2Title: "2. Benutzerkonto & Profilbilder",
  section2Text: "Für die aktive Teilnahme (Hinzufügen von Websites) ist eine Registrierung erforderlich. Hierbei speichern wir Benutzername, E-Mail-Adresse und Passwort (verschlüsselt). Optional können Sie ein Profilbild hochladen. Dieses Bild wird auf unseren Servern gespeichert und ist im Zusammenhang mit Ihren Aktivitäten (z.B. Einträgen oder Kommentaren) für andere Nutzer sichtbar. Sie können das Bild jederzeit in Ihren Profileinstellungen ändern oder löschen.",
  section3Title: "3. Verlinkungen zu externen Angeboten",
  section3Text: "Unser Angebot enthält Links zu externen Webseiten Dritter (z.B. archivierte Websites). Wir haben keinen Einfluss darauf, dass diese Anbieter die Datenschutzbestimmungen einhalten. Für die Inhalte und Datenschutzpraktiken der verlinkten Seiten übernehmen wir keine Haftung. Bitte informieren Sie sich in den Datenschutzerklärungen der jeweiligen Anbieter.",
  section4Title: "4. Datensicherheit & Verschlüsselung",
  section4Text: "Diese Seite nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Ihrer Registrierungsdaten, eine SSL- bzw. TLS-Verschlüsselung. Passwörter werden nach aktuellen Sicherheitsstandards (bcrypt) gehasht gespeichert und sind für Administratoren nicht im Klartext einsehbar.",
  section5Title: "5. Ihre Rechte als betroffene Person",
  section5Text: "Sie haben jederzeit das Recht auf unentgeltliche Auskunft ueber Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfaenger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Loeschung dieser Daten. Wenn Sie eingeloggt sind, koennen Sie den Download Ihrer Daten und die Loeschung Ihres Kontos unter Mein Account > Daten & Datenschutz starten. Wenden Sie sich fuer weitere Anfragen bitte an die im Impressum angegebene Adresse.",
  section6Title: "6. Verantwortliche Stelle",
  section6Text: "Verantwortlich für die Datenverarbeitung auf dieser Website im Sinne der Datenschutz-Grundverordnung (DSGVO) ist die Projektleitung:",
  contactName: "Projekt WebKurator (Uni Passau)",
  contactUni: "Entwicklungspraktikum Gruppe 2",
  contactMail: "webkurator@fim.uni-passau.de"
};

export const terms = {
  title: "Nutzungsbedingungen",
  subtitle: "Regeln für die Nutzung von WebKurator (in Anlehnung an Curlie)",

  // 1. Akzeptanz
  scope: "1. Akzeptanz der Bedingungen",
  scopeText1: "Durch die Nutzung von WebKurator in jeglicher Weise erklären Sie sich mit diesen Bedingungen einverstanden. Diese Nutzungsbedingungen ('TOS') sind ein Vertrag zwischen Ihnen und der Projektgruppe 'WebKurator' der Universität Passau.",
  scopeText2: "Wenn Sie den Bestimmungen dieser TOS nicht folgen können oder wollen, stimmen Sie zu, WebKurator nicht zu nutzen. WebKurator ist ein studentisches Projekt; wir übernehmen keine Verantwortung dafür, dass der Dienst lokalen Gesetzen außerhalb Deutschlands entspricht.",

  // 2. Nutzergruppen
  userGroups: "2. Zugriffsrechte & Rollen",
  anonymousUsers: "Besucher",
  anonymousRight1: "Dürfen das Verzeichnis durchsuchen.",
  anonymousRight2: "Können Webseiten zur Aufnahme vorschlagen.",
  anonymousRight3: "Haben keinen Anspruch auf Aufnahme ihrer Vorschläge.",

  registeredUsers: "Kuratoren (Editoren)",
  registeredRight1: "Können Webseiten direkt zum Verzeichnis hinzufügen.",
  registeredRight2: "Sind verantwortlich für die Richtigkeit ihrer Beiträge.",
  registeredRight3: "Stimmen der Protokollierung ihrer Aktivitäten zu.",

  // 3. Account
  registrationAccount: "3. Benutzerkonto",
  registrationIntro: "Für die aktive Teilnahme ist ein Konto erforderlich:",
  regEmail: "Gültige E-Mail-Adresse",
  regUsername: "Benutzername (öffentlich sichtbar)",
  regPassword: "Sicheres Passwort",
  registrationText1: "Sie sind allein verantwortlich für alle Aktivitäten, die unter Ihrem Konto stattfinden. Da dies eine Testumgebung ist, nutzen Sie bitte keine Passwörter, die Sie auch für kritische Dienste verwenden.",
  registrationText2: "Wir behalten uns das Recht vor, Konten jederzeit ohne Vorankündigung zu kündigen.",

  // 4. Verantwortlichkeiten
  userObligations: "4. Ihre Verantwortlichkeiten",
  userObligationsIntro: "Sie sind für Ihre eigenen Aktivitäten bei der Nutzung von WebKurator verantwortlich. Sie verpflichten sich:",
  obligation1: "Das Funktionieren von WebKurator nicht zu stören oder zu beeinträchtigen.",
  obligation2: "Keine illegalen Aktivitäten zu fördern oder daran teilzunehmen (z.B. Verlinkung auf illegale Inhalte).",
  obligation3: "Keine automatisierten Systeme (Bots/Scraper) ohne Genehmigung einzusetzen.",
  obligation4: "Die alleinige Verantwortung für Inhalte zu übernehmen, die Sie posten oder vorschlagen.",

  // 5. Ermessen
  terminationTitle: "5. Ermessen über Inhalte & Betrieb",
  terminationText: "Wir können Inhalte im Verzeichnis (einschließlich der von Ihnen bereitgestellten Inhalte) jederzeit ohne Vorankündigung oder Haftung nach unserem alleinigen Ermessen bearbeiten, verschieben oder löschen. Sie erkennen an, dass WebKurator das uneingeschränkte redaktionelle Ermessen hat, die Struktur und den Inhalt des Verzeichnisses zu bestimmen. Sie haben keinen Anspruch auf Aufnahme oder Verbleib einer Seite im Verzeichnis.",

  // 6. Datenqualität
  dataQuality: "6. Datenqualität",
  dataQualityText1: "WebKurator wird auf einer 'AS IS' (wie besehen) Basis bereitgestellt.",
  dataQualityText2: "Wir geben keine Zusicherungen bezüglich der Genauigkeit, Qualität, Aktualität oder Vollständigkeit der verfügbaren Informationen.",

  // 7. Haftung
  liability: "7. Haftungsausschluss",
  liabilityText1: "SIE NUTZEN DEN DIENST AUF EIGENES RISIKO. WebKurator und die Projektgruppe haften nicht für Fehler oder Auslassungen im Inhalt oder für Verluste oder Schäden, die aus der Nutzung entstehen, es sei denn, es liegt Vorsatz oder grobe Fahrlässigkeit vor.",
  liabilityText2: "Wir sind nicht verantwortlich für die Inhalte verlinkter Drittanbieter-Seiten. Sie verzichten auf jegliche Ansprüche, die aus Ihrer Nutzung externer Links entstehen.",

  // 8. Urheberrecht
  copyright: "8. Rechteeinräumung",
  copyrightText1: "Um uns den Betrieb des Verzeichnisses zu ermöglichen, räumen Sie WebKurator mit dem Einsenden von Inhalten (Titel, Beschreibungen) das nicht-exklusive, gebührenfreie Recht ein, dieses Material im Verzeichnis zu nutzen, zu kopieren und anzupassen.",
  copyrightText2: "Sie garantieren, dass Sie über alle erforderlichen Rechte verfügen, um die Verbreitung des von Ihnen eingereichten Materials zu genehmigen.",

  // 9. Copyright Claims
  copyrightClaims: "9. Meldung von Urheberrechtsverletzungen",
  copyrightClaimsText: "Wir respektieren die geistigen Eigentumsrechte anderer. Wenn Sie glauben, dass Ihr Werk auf WebKurator in einer Weise kopiert wurde, die eine Urheberrechtsverletzung darstellt, kontaktieren Sie uns bitte unter webkurator@fim.uni-passau.de. Wir behalten uns vor, den Zugang von Nutzern zu sperren, die wiederholt Rechte Dritter verletzen.",

  // 10. Änderungen
  changes: "10. Änderungen der Bedingungen",
  changesText: "Wir können diese Nutzungsbedingungen jederzeit ohne Vorankündigung ändern. Ihre fortgesetzte Nutzung von WebKurator nach dem Datum des Inkrafttretens von Änderungen gilt als Zustimmung zu den Änderungen.",

  // 11. Recht
  jurisdiction: "11. Schlussbestimmungen",
  jurisdictionText: "Es gilt das Recht der Bundesrepublik Deutschland. Ausschließlicher Gerichtsstand für alle Streitigkeiten ist Passau.",
  lastUpdated: "Stand:",
  contactInfo: "Kontakt:"
};

export const help = {
  title: "Hilfe & FAQ",
  subtitle: "Häufig gestellte Fragen und Anleitungen zur Nutzung von WebKurator.de",
  quickLinkSearch: "Suche verwenden",
  quickLinkSearchDesc: "Lernen Sie, wie Sie effektiv nach Websites suchen",
  quickLinkRegistration: "Registrierung",
  quickLinkRegistrationDesc: "Anleitung zur Erstellung eines Nutzerkontos",
  quickLinkCategorization: "Kategorisierung",
  quickLinkCategorizationDesc: "Wie Sie Websites kategorisieren",
  generalQuestions: "Allgemeine Fragen",
  q1: "Was ist WebKurator",
  a1: "WebKurator ist ein studentisches Projekt der Universität Passau zur systematischen Erfassung und Kategorisierung von Webseiten. Die Plattform ermöglicht es Nutzern, gemeinsam ein strukturiertes Verzeichnis von Internetquellen aufzubauen.",
  q2: "Wer kann WebKurator nutzen",
  a2: "Die Plattform ist für alle zugänglich. Besucher können suchen und stöbern. Registrierte Nutzer können aktiv mitarbeiten, Webseiten hinzufügen und kategorisieren. Das Projekt dient Lehrzwecken.",
  q3: "Ist die Nutzung kostenlos",
  a3: "Ja, WebKurator ist vollständig kostenlos nutzbar. Es handelt sich um ein nicht-kommerzielles Open-Source-Projekt im Rahmen eines Software-Praktikums.",
  q4: "Welche Websites werden erfasst",
  a4: "Der Fokus liegt auf Webseiten aus und über Deutschland, aber die Community entscheidet über die genaue Ausrichtung. Ziel ist eine breite Sammlung thematisch relevanter Inhalte.",

  searchNavigation: "Suche und Navigation",
  q5: "Wie verwende ich die Suchfunktion",
  a5Intro: "Geben Sie Suchbegriffe in das Suchfeld ein. Die Suche durchsucht Titel, Beschreibungen und URLs der erfassten Websites.",
  a5Bullet1: "Verwenden Sie mehrere Suchbegriffe für genauere Ergebnisse",
  a5Bullet2: "Nutzen Sie Filter, um nach Kategorien oder Regionen einzugrenzen",
  a5Bullet3: "Sortieren Sie Ergebnisse nach Relevanz, Datum oder alphabetisch",
  q6: "Wie durchsuche ich nach Kategorien",
  a6: 'Navigieren Sie zur Seite "Kategorien" über das Hauptmenü. Dort können Sie zwischen thematischer und regionaler Kategorisierung wählen. Klicken Sie auf eine Kategorie, um alle zugehörigen Websites anzuzeigen.',
  q7: "Was bedeuten die verschiedenen Sortieroptionen",
  a7Sort1: "Relevanz:",
  a7Sort1Desc: "Sortiert nach Übereinstimmung mit Ihrer Suchanfrage",
  a7Sort2: "Neueste zuerst:",
  a7Sort2Desc: "Zeigt zuletzt hinzugefügte Websites zuerst",
  a7Sort3: "Älteste zuerst:",
  a7Sort3Desc: "Zeigt am längsten archivierte Websites zuerst",
  a7Sort4: "A-Z / Z-A:",
  a7Sort4Desc: "Alphabetische Sortierung nach Titel",

  registrationAndAccount: "Registrierung und Konto",
  q8: "Wie registriere ich mich",
  a8Step1: 'Klicken Sie auf "Registrieren" im Hauptmenü',
  a8Step2: "Geben Sie Benutzername, E-Mail und ein sicheres Passwort ein",
  a8Step3: "Bestätigen Sie Ihre E-Mail-Adresse über den zugesendeten Link",
  a8Step4: "Melden Sie sich mit Ihren Zugangsdaten an",
  q9: "Welche Anforderungen hat das Passwort",
  a9Intro: "Ein sicheres Passwort muss folgende Kriterien erfüllen:",
  a9Req1: "Mindestens 8 Zeichen lang",
  a9Req2: "Mindestens einen Großbuchstaben",
  a9Req3: "Mindestens einen Kleinbuchstaben",
  a9Req4: "Mindestens eine Ziffer",
  a9Req5: "Mindestens ein Sonderzeichen",
  q10: "Ich habe mein Passwort vergessen",
  a10: 'Klicken Sie auf der Login-Seite auf "Passwort vergessen" und geben Sie Ihre E-Mail-Adresse ein. Sie erhalten einen Link zum Zurücksetzen Ihres Passworts per E-Mail.',
  q11: "Wie ändere ich meine Kontoinformationen",
  a11: 'Nach der Anmeldung finden Sie unter "Mein Account" im Benutzermenü die Möglichkeit, E-Mail-Adresse, Benutzername und Passwort zu ändern. Änderungen der E-Mail-Adresse müssen über einen Bestätigungslink verifiziert werden.',

  addingWebsites: "Websites hinzufügen und bearbeiten",
  q12: "Wie füge ich eine neue Website hinzu",
  a12Intro: "Als registrierter Nutzer können Sie neue Websites hinzufügen:",
  a12Step1: "Melden Sie sich an",
  a12Step2: 'Klicken Sie auf "Website hinzufügen"',
  a12Step3: "Geben Sie Titel, URL und Beschreibung ein",
  a12Step4: "Wählen sie eine passende Kategorie",
  a12Step5: "Speichern Sie den Eintrag",
  q13: "Wie kategorisiere ich eine Website",
  a13: "Bei der Kategorisierung können Sie thematische und regionale Kategorien vergeben. Das System macht automatische Vorschläge basierend auf dem Inhalt der Website (Machine Learning). Sie können diese Vorschläge übernehmen oder eigene Kategorien auswählen.",
  q14: "Kann ich Einträge anderer Nutzer bearbeiten",
  a14: "Ja, registrierte Nutzer können alle Einträge bearbeiten und kategorisieren. Dies fördert die kollaborative Qualitätssicherung. Alle Änderungen werden protokolliert.",
  q15: "Was passiert mit meinen Vorschlägen als anonymer Nutzer",
  a15: "Vorschläge anonymer Nutzer werden von registrierten Nutzern geprüft. Diese können den Vorschlag annehmen, anpassen oder ablehnen. Sie erhalten keine Benachrichtigung über die Entscheidung.",
  needMoreHelp: "Weitere Hilfe benötigt",
  needMoreHelpDesc: "Wenn Sie Ihre Frage hier nicht finden, kontaktieren Sie uns",
  supportTeam: "Unser Support-Team hilft Ihnen gerne weiter:",
  viewContactInfo: "Kontaktdaten ansehen",
};





